import React, { FC } from 'react'

import { Page, PageContent } from 'common'
import { Header } from 'components'

import { Skeleton } from '@interco/inter-ui/components/Skeleton'

import {
  ButtonContainer,
  ChipContainer,
  MyServicesSkeletonContainer,
} from '../styles/MyServices.styles'

export const MyServicesSkeleton: FC<{ pageTitle: string }> = ({ pageTitle }) => (
  <Page>
    <Header title={pageTitle} />
    <ChipContainer>
      <Skeleton height="2rem" width="5.5rem" style={{ borderRadius: '16px' }} />
    </ChipContainer>
    <PageContent>
      <MyServicesSkeletonContainer>
        <Skeleton height="4rem" width="100%" style={{ marginTop: '16px' }} />
        <Skeleton height="4rem" width="100%" style={{ marginTop: '16px' }} />
        <Skeleton height="4rem" width="100%" style={{ marginTop: '16px' }} />
      </MyServicesSkeletonContainer>
    </PageContent>
    <ButtonContainer $hasScroll={false}>
      <Skeleton height="4rem" width="100%" />
    </ButtonContainer>
  </Page>
)
